





  









  


  



import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    user: null,
    isLoading: true
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUserDetails: (state, action) => {
            state.user = action.payload
            state.isLoading = false
        },
        setIsLoading: (state, action) => {
            state.isLoading = action.payload
        },
        clearUserData: (state) => {
            state.user = null
            state.isLoading = false
        }
    },
})


export const { setUserDetails, setIsLoading, clearUserData } = userSlice.actions

export default userSlice.reducer
